export default __webpack_public_path__ + "static/media/kellygreen.358e043a.jpg";